export const PASSENGER_FORM_BOTTOM_SHEET = 'passenger-form-bottom-sheet';
export const PASSENGER_ADD_METHOD_BOTTOM_SHEET =
  'passenger-add-method-bottom-sheet';
export const PASSENGER_DOCUMENT_PHOTO_BOTTOM_SHEET =
  'passenger-document-photo-bottom-sheet';

export const PASSENGERS_SESSION_STORAGE_KEY = 'free-avia:passengers';
